export const BREATHING_SPEEDS = {
    FAST: { // anger, anxiety, euphoria
        breathSpeed: 5,
        breathAmplitude: 20
    },
    MEDIUM_FAST: { // anger, anxiety, euphoria
        breathSpeed: 2,
        breathAmplitude: 20
    },
    MEDIUM: { // happy
        breathSpeed: 1.0,
        breathAmplitude: 50
    },
    SLOW: { // sad, calm
        breathSpeed: 0.3,
        breathAmplitude: 10
    }
};


export const ANIMATION_SPEED = {
    DEFAULT: { speed: 0.01 },
    MEDIUM: { speed: 0.03 },
    FAST: { speed: 0.05 }
};